module.exports = __webpack_public_path__ + "img/gia-chicago.916698b9.jpg";